import React from 'react';
import { formatCurrency } from '../utils/currencyFormatter';
import { getCountryName } from '../utils/countryUtils';
import { PlusIcon, CheckIcon, XIcon } from 'lucide-react';
export function EntityList({
  entities,
  onSelectEntity,
  onCreateEntity,
  locale
}) {
  return <div className="bg-white shadow overflow-hidden sm:rounded-md" data-id="element-15403">
      <div className="px-4 py-5 sm:px-6 flex justify-between items-center" data-id="element-15404">
        <div data-id="element-15405">
          <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-15406">
            Entities
          </h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-15407">
            A list of all the entities in your organization
          </p>
        </div>
        <button type="button" onClick={onCreateEntity} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-15408">
          <PlusIcon className="h-4 w-4 mr-2" data-id="element-15409" />
          Add Entity
        </button>
      </div>
      <div className="border-t border-gray-200" data-id="element-15410">
        <ul className="divide-y divide-gray-200" data-id="element-15411">
          {entities.map(entity => <li key={entity.id} data-id="element-15412">
              <button onClick={() => onSelectEntity(entity)} className="w-full text-left hover:bg-gray-50 px-4 py-4 sm:px-6 flex items-center justify-between" data-id="element-15413">
                <div data-id="element-15414">
                  <div className="flex items-center" data-id="element-15415">
                    <p className="text-sm font-medium text-indigo-600 truncate" data-id="element-15416">
                      {entity.name}
                    </p>
                    <p className="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800" data-id="element-15417">
                      {entity.code}
                    </p>
                    {entity.isActive ? <span className="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-15418">
                        <CheckIcon className="h-3 w-3 mr-1" data-id="element-15419" />
                        Active
                      </span> : <span className="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800" data-id="element-15420">
                        <XIcon className="h-3 w-3 mr-1" data-id="element-15421" />
                        Inactive
                      </span>}
                  </div>
                  <div className="mt-2 sm:flex sm:justify-between" data-id="element-15422">
                    <div className="sm:flex" data-id="element-15423">
                      <p className="flex items-center text-sm text-gray-500" data-id="element-15424">
                        {getCountryName(entity.country)}
                      </p>
                      <p className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6" data-id="element-15425">
                        {entity.currency}
                      </p>
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0" data-id="element-15426">
                      <p data-id="element-15427">
                        {entity.sites.length}{' '}
                        {entity.sites.length === 1 ? 'site' : 'sites'}
                      </p>
                    </div>
                  </div>
                </div>
              </button>
            </li>)}
          {entities.length === 0 && <li className="px-4 py-5 sm:px-6 text-center text-sm text-gray-500" data-id="element-15428">
              No entities found. Click "Add Entity" to create one.
            </li>}
        </ul>
      </div>
    </div>;
}